import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Title } from "../Title/Title";
import * as styles from "./bannerD.module.scss";

interface Props {
  text: string;
  active?: boolean;
}

export const BannerD: React.FC<Props> = ({ text, active }) => {
  return (
    <div className={styles.banner}>
      <div className={styles.anim}>
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}

        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
        <Title text={text} className={styles.warning} />
        {active && (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={styles.icon}
          />
        )}
      </div>
    </div>
  );
};
